module.exports = __webpack_public_path__ + "media/images/lb/710-5272da8d52f001dfa19adfa8aa8f3a49.svg";